var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtrlDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_20787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 11.9998C7.76784 11.9998 7.53684 11.9198 7.34884 11.7588L-0.410156 5.10884L0.891844 3.58984L7.99984 9.68284L15.1078 3.58984L16.4098 5.10884L8.65084 11.7588C8.46284 11.9198 8.23184 11.9998 7.99984 11.9998Z",
    fill: "#5578F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_20787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtrlDown);
export default __webpack_public_path__ + "static/media/ctrl-down.f0f63fb19d933357f2403fbd4129183d.svg";
export { ForwardRef as ReactComponent };